import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import messages from '../messages';

const S = {
  Wrapper: styled.div.attrs(({ position }) => ({
    style: {
      transform: `translate(${position.x}px, ${position.y}px)`,
    },
  }))`
    position: fixed;
    top: 0;
    left: 0;
    width: 120px;
    padding: 8px 16px 9px;
    border-radius: 24px;
    color: ${({ theme }) => theme.palette.grey[900]};
    background-color: ${({ theme }) => theme.palette.status.note.background};
    font-size: ${({ theme }) => theme.typography.pxToRem(15)};
    font-weight: 500;
    text-align: right;
    ::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 12px;
      transform: translateY(-50%);
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background-color: ${({ theme }) => theme.palette.status.note.main};
    }
  `,
};

const SignatureCursorFollower = ({ position }) => (
  <S.Wrapper position={position}>
    <FormattedMessage {...messages.signatureCursorFollower} />
  </S.Wrapper>
);

SignatureCursorFollower.propTypes = {
  position: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
  }).isRequired,
};

export default SignatureCursorFollower;
